"use client";

import { c as _c } from "react/compiler-runtime";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { StatefulColorPicker } from "@/ui/stateful-color-picker";
export const CategoryMenuForm = t0 => {
  const $ = _c(22);
  const {
    theme
  } = t0;
  const context = useStoreBuilderContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Background Color</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = theme.backgroundColor;
  let t3;
  if ($[1] !== context) {
    t3 = debounce(value => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "backgroundColor",
        value
      });
    }, 300, {
      trailing: true
    });
    $[1] = context;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== theme.backgroundColor) {
    t4 = <Label className="grid gap-2 w-max">{t1}<StatefulColorPicker defaultValue={t2} onValueChange={t3} /></Label>;
    $[3] = t3;
    $[4] = theme.backgroundColor;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>Font Color</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = theme.color;
  let t7;
  if ($[7] !== context) {
    t7 = debounce(value_0 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "color",
        value: value_0
      });
    }, 300, {
      trailing: true
    });
    $[7] = context;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7 || $[10] !== theme.color) {
    t8 = <Label className="grid gap-2 w-max">{t5}<StatefulColorPicker defaultValue={t6} onValueChange={t7} /></Label>;
    $[9] = t7;
    $[10] = theme.color;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>Hover Background Color</span>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = theme.hoverBackgroundColor;
  let t11;
  if ($[13] !== context) {
    t11 = debounce(value_1 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "hoverBackgroundColor",
        value: value_1
      });
    }, 300, {
      trailing: true
    });
    $[13] = context;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== theme.hoverBackgroundColor) {
    t12 = <Label className="grid gap-2 w-max">{t9}<StatefulColorPicker defaultValue={t10} onValueChange={t11} /></Label>;
    $[15] = t11;
    $[16] = theme.hoverBackgroundColor;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t4 || $[20] !== t8) {
    t13 = <div className="grid gap-4 relative pb-20">{t4}{t8}{t12}</div>;
    $[18] = t12;
    $[19] = t4;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};